import { render, staticRenderFns } from "./start-membership.vue?vue&type=template&id=8bab875e&"
import script from "./start-membership.vue?vue&type=script&lang=js&"
export * from "./start-membership.vue?vue&type=script&lang=js&"
import style0 from "./start-membership.vue?vue&type=style&index=0&id=8bab875e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports